export default __webpack_public_path__ + "static/media/print_bill_1.f6e55b0e.svg";